import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { FlaskConical } from 'lucide-react'
import type React from 'react'

interface LabMarkerProps {
	'data-testid': string
	className?: string
	side?: React.ComponentProps<typeof TooltipContent>['side']
	/** Pass `false` inside a link, which already takes the focus. */
	focusable?: boolean
}

export function LabMarker({ 'data-testid': testId, className, side, focusable }: LabMarkerProps) {
	return (
		<Tooltip>
			<TooltipTrigger asChild focusable={focusable}>
				<span
					role='img'
					aria-label='Labs'
					data-testid={testId}
					className={cn('inline-flex shrink-0 text-warning', className)}>
					<FlaskConical className='size-(--icon-standalone)' />
				</span>
			</TooltipTrigger>
			<TooltipContent side={side}>Labs</TooltipContent>
		</Tooltip>
	)
}
